import script from "./NotFoundBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundBoard.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundBoard.vue?vue&type=style&index=0&id=74bcbf7b&lang=scss"

const __exports__ = script;

export default __exports__